/**
 * Conversation channel helpers — mirror of the backend's `conversation-channel.ts`.
 *
 * Instagram conversations ride on the phone-keyed schema with `ig:`-prefixed identifiers
 * (`ig:<botName>` for the line, `ig:<instagramUserId>` for the customer), so the channel is
 * derived from the prefix instead of a dedicated column.
 */
export type ConversationChannel = 'whatsapp' | 'instagram';

const INSTAGRAM_ID_PREFIX = 'ig:';

export function isInstagramId(id: string | null | undefined): boolean {
  return typeof id === 'string' && id.startsWith(INSTAGRAM_ID_PREFIX);
}

export function channelOf(id: string | null | undefined): ConversationChannel {
  return isInstagramId(id) ? 'instagram' : 'whatsapp';
}

/** Identifier as shown to operators: the raw IG user id/handle without the `ig:` prefix. */
export function displayId(id: string): string {
  return isInstagramId(id) ? id.slice(INSTAGRAM_ID_PREFIX.length) : id;
}
